import B2BMarkupSummaryModel from "src/models/B2BMarkupSummaryModel"
import { fetchMarkupSummary } from "../MarkupManagerSlice";

export const convertToB2BMarkupSummary = (results) => {
    const model = new B2BMarkupSummaryModel(results);
    return {
        B2BMarkupSummaries: model.B2BMarkupSummaries
    };
}

export const fetchB2BMarkups = (instance, accounts) => async (dispatch) => {
    const response = await dispatch(fetchMarkupSummary(instance, accounts));
    return response || [];
};